
class PlotStateUtil {
    static fixPlotState = (plotState) => {
        // Upgrading to version 1
        if(!plotState.version) {
            let _state = {};
            _state.version = 1;
            _state.plotview = Object.assign({}, plotState);

            if ( "toolBar" in _state.plotview ) {
                _state.language = _state.plotview.toolBar.language
                delete _state.plotview.toolBar;
            }
            plotState = _state;
        }
        
        // Upgrading to version 2
        if(plotState.version === 1) {
            plotState.conf = Object.assign({}, plotState.options);
            if(plotState.language) {
                plotState.conf.language = plotState.language;
            }
            if(plotState.theme) {
                plotState.conf.theme = plotState.theme;
            }
            delete plotState.options;
            delete plotState.theme;
            delete plotState.language;
            plotState.version = 2;
        }
        return plotState;
    }
}

export default PlotStateUtil;
